/**
 * Executor-assignment (task) lifecycle statuses.
 * Source of truth — keep in sync with sara node [[WORKFLOW-ASSIGNMENT-LIFECYCLE]].
 *
 * Lives in Ship/ because the same map is consumed by
 * RequestContainer / AssignmentContainer (domain) AND by the cross-cutting
 * dashboard in HomeContainer. RequestContainer's own Contracts/TaskStatus.ts
 * is now a thin re-export of this module.
 */
export type TaskStatus =
    | 'new'
    | 'assigned_executor'
    | 'execution_started'
    | 'loading_started'
    | 'arrived_at_unloading'
    | 'unloading_started'
    | 'completed_by_driver'
    | 'completed_by_dispatcher'

export const TASK_STATUS_MAP: Record<TaskStatus, { label: string; color: string }> = {
    new: { label: 'Нова', color: '#8c8c8c' },
    assigned_executor: { label: 'Виконавець призначений', color: '#1890ff' },
    execution_started: { label: 'Виконання розпочато', color: '#13c2c2' },
    loading_started: { label: 'Завантаження розпочато', color: '#faad14' },
    arrived_at_unloading: { label: 'Прибув на розвантаження', color: '#722ed1' },
    unloading_started: { label: 'Розвантаження розпочато', color: '#eb2f96' },
    completed_by_driver: { label: 'Завершено водієм', color: '#a0d911' },
    completed_by_dispatcher: { label: 'Підтверджено диспетчером', color: '#52c41a' },
}

/**
 * Незавершені задачі (водій ще не завершив): для «без водія / без ТЗ» на головній і маркера
 * activeStatus у списку. Має збігатися з DashboardSummaryAction::ACTIVE_ASSIGNMENT_STATUSES.
 */
export const ACTIVE_TASK_STATUSES: TaskStatus[] = [
    'new',
    'assigned_executor',
    'execution_started',
    'loading_started',
    'arrived_at_unloading',
    'unloading_started',
]
